










































import { Component, Prop, Vue } from "vue-property-decorator";
import DoKoHtmlDialog from "../DoKoHtmlDialog.vue";
import DoKoBtn from "../../../components/controls/DoKoBtn.vue";
import { Restriction } from "@dokogd/shared";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoRestrictionWedding extends Vue {
  onConfirm(val: Restriction) {
    console.log("PLAY", val);
    this.$emit("announce-restriction", val);
  }
}
